export default __webpack_public_path__ + "static/media/NIAS0140.34I-32743_-17893_0.185ea4a1.jpg";